import { useMutation } from '@tanstack/react-query'
import { splitAddress } from '@mobi/account/Common'
import { AccountHolderAddress } from '@mobi/api-types'
import { toTitleCase } from '@mobi/utils/string'
import { getStreetTypeFromAbbreviation } from '../utils'

export type AddressSplitResult = Omit<AccountHolderAddress, 'postcode'> & { postCode: string }

export const useSplitAddress = ({
  onSuccess,
  onError,
}: {
  onSuccess: (address: AccountHolderAddress) => void
  onError: (error: Error) => void
}) =>
  useMutation({
    mutationFn: (addressMonikerId: string) => splitAddress(addressMonikerId),
    onSuccess: (address: AddressSplitResult) => onSuccess(transformAddress(address)),
    onError,
  })

const transformAddress = (address: AddressSplitResult): AccountHolderAddress => ({
  unitNumber: address.unitNumber,
  streetNumber: address.streetNumber,
  streetName: toTitleCase(address.streetName),
  streetType: getStreetTypeFromAbbreviation(address.streetType),
  suburb: address.suburb?.toLocaleUpperCase(),
  postcode: address.postCode,
  state: address.state,
  country: toTitleCase(address.country?.toLocaleLowerCase()),
})
